import { useState, useEffect } from 'react';
import classNames from '../../../node_modules/classnames/index';

const BioBlock = ({ absolute, mode = 'auto', max, bio, className = 'block-html leading-6  text-xs md:text-sm', containerClass }) => {
    const [isReadMore, setIsReadMore] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    // const regex = new RegExp(/^Days \d*$/);
    const regex = new RegExp(/\[read more]/gm);
    useEffect(() => {
        switch (mode) {
            case 'auto':
                setIsReadMore(regex.test(bio));
                break;

            case 'charCount':
                if (max) {
                    setIsReadMore(bio.length > max);
                } else setIsReadMore(false);
                break;
            default:
                break;
        }
    }, [bio]);

    const filterBio = (text, mode, max) => {
        switch (mode) {
            case 'auto':
                if (isReadMore) {
                    if (isOpen) return text.replace('[read more]', '');
                    else return text.split('[read more]')[0];
                } else return text;

            case 'charCount':
                if (max) {
                    if (isOpen) return text;
                    else return `${bio.slice(0, max)}...`;
                } else return text;

            default:
                return text;
        }
    };

    return (
        <div className={containerClass}>
            <div
                className={className}
                dangerouslySetInnerHTML={{
                    __html: filterBio(bio, mode, max)
                }}
            />
            {isReadMore && (
                <button
                    onClick={() => setIsOpen(!isOpen)}
                    className={classNames(
                        absolute && 'absolute z-1000',
                        'focus:outline-none text-xs hover:bg-gray-900  hover:text-white bg-gray-200 text-gray-600 rounded-full px-4 py-1 mb-4 '
                    )}
                >
                    {isOpen ? 'Read Less' : 'Read More'}
                </button>
            )}
        </div>
    );
};
export default BioBlock;
